<template>
  <div class="content hospitais p-1">
    <h4 class="hospitais_title">
      <b>Hospitais</b>
    </h4>

    <div class="pl-3 pr-3">
      <b-row align-h="between">
        <div class="ml-3 mt-1 col-4 p-0">
          <div class="form-group">
            <label for="busca"
                   class="hospitais_label">Buscar Hospital</label>
            <input id="busca"
                   v-model="search"
                   class="col-md-12 form-control form-control-sm"
                   name="busca"
                   placeholder="Digite o nome do hospital para pesquisa"
                   type="text">
          </div>
        </div>
        <div>
          <div class="mt-3 mr-3">
            <b-button variant="secondary"
                      size="sm"
                      @click="showModal()">
              <svg class="button_edit_label_icon icon--xxs"
                   role="presentation">
                <use :xlink:href="'#' + add.id" />
              </svg>
              Adicionar hospital
            </b-button>
          </div>
        </div>
      </b-row>

      <Table
        :fields="fields"
        :data="hospitais"
        :is-busy="isBusy"
        :search="search"
        field-search="nome"
        @showModal="showModal"
        @onUpdateAtivo="updateAtivo" />
    </div>

    <Pagination
      :per-page="perPage"
      :page="page"
      :last-page="lastPage"
      @onPreviousPage="previousPage"
      @onNextPage="nextPage" />


    <form autocomplete="off"
          class="no-padding"
          @submit.prevent="callMethod()">
      <BoxModal :read="read"
                :form="form"
                :tipo="'Hospital'"
                @changeRead="changeRead"
                @onEnderecoAdd="changeData" />
    </form>
  </div>
</template>

<script>
  /* components */
  import Pagination from "@/components/SofiaRei/Pagination"
  import Table from "@/components/SofiaRei/Table"
  import BoxModal from "@/components/SofiaRei/Cruds/BoxModal"

  /* services */
  import HospitaisService from "@/services/HospitaisService"

  /* assets */
  import excludeIcon from "@/assets/icons/ic_delete_24px.svg?sprite"
  import editIcon from "@/assets/icons/pencil.svg?sprite"
  import eyeIcon from "@/assets/icons/eye.svg?sprite"
  import add from '@/assets/icons/add.svg?sprite'

  /* outros */
  import debounce from 'lodash/debounce'
  import { mapGetters } from 'vuex'

  export default {
    name: "Hospitais",
    components: {
      Pagination,
      Table,
      BoxModal,
    },
    data () {
      return {
        search: null,
        isBusy: false,
        perPage: 10,
        page: 1,
        lastPage: 1,
        excludeIcon,
        editIcon,
        eyeIcon,
        add,
        read: false,
        title: 'Novo hospital',
        fields: [{
          key: 'id',
          label: 'Ativo'
        },{
          key: 'nome',
          label: 'Nome'
        },{
          key: 'telefone',
          label: 'Telefone'
        },{
          key: 'email',
          label: 'Email'
        },{
          key: 'endereco.uf',
          label: 'Estado'
        },{
          key: 'endereco.cidade',
          label: 'Cidade'
        },{
          key: 'acoes',
          label: ''
        }],
        hospitais: [],
        form: {
          cartorio_id: this.$store.state.auth.cartorio_id,
          nome: null,
          telefone: null,
          email: null,
          ativo: 1,
          endereco: {
            cep: null,
            logradouro: null,
            numero: null,
            complemento: null,
            bairro: null,
            cidade: null,
            uf: null,
            codigo_ibge_id: null
          }
        }
      }
    },
    computed: {
      ...mapGetters({
        cartorioId: 'auth/getCartorioId'
      }),
    },
    watch: {
      search: function (newSearch, oldSearch) {
        this.isBusy = true
        this.viewWatch()
      }
    },
    beforeMount () {
      try {
        loader({ text: "Obtendo dados...", active: true })
        this.init()
      } catch (e) {
        loader({ text: "", active: false })
      }
    },
    created () {
      this.viewWatch = debounce(function () {
        this.searchHospital()
      }, 200)
    },
    methods: {
      async init () {
        let data = await HospitaisService.getHospitais({
          cartorio_id: this.$store.state.auth.cartorio_id,
          perPage: this.perPage,
          page: this.page
        })
        this.hospitais = data.data
        this.lastPage = data.lastPage
        this.isBusy = false
        loader({ text: "", active: false })
      },
      async showModal (hospital = { data: {}, read: false }) {
        const { data, read } = hospital
        this.read = read
        if (data.hospital_id) {
          this.form.hospital_id = data.hospital_id
          this.form.nome = data.nome
          this.form.email = data.email
          this.form.telefone = data.telefone
          this.form.ativo = data.ativo
          this.form.endereco = data.endereco
          this.form.editar = true
        } else {
          this.form = {
            cartorio_id: this.$store.state.auth.cartorio_id,
            nome: null,
            telefone: null,
            email: null,
            ativo: 1,
            endereco: {
              cep: null,
              logradouro: null,
              numero: null,
              complemento: null,
              bairro: null,
              cidade: null,
              uf: null,
              codigo_ibge_id: null
            },

          }
        }

        this.$bvModal.show('modal-cadastro')
      },
      async callMethod () {
        this.$bvModal.hide('modal-cadastro')
        loader({ text: "Aguarde...", active: true })

        if (this.form.hospital_id) {
          this.updateHospital(this.form)
        } else {
          this.saveHospital(this.form)
        }
      },
      async saveHospital (hospital) {
        try {
          let data = await HospitaisService.saveHospitais(hospital)
          if (data.hospital_id) {
            objSwal.success.title = "Salvo com sucesso!"
            objSwal.success.text = ''
            Swal.fire(objSwal.success)
          } else {
            objSwal.warning.title = "Erro ao salvar, tente novamente!"
            Swal.fire(objSwal.warning)
          }
        } catch (error) {
          const message = getErrors(error)

          return displayMessage('error', 'Erro!', message.message)
        } finally {
          this.init()

          loader({ text: "", active: false })
        }
      },
      async updateHospital (hospital, alert = true) {
        try {
          const { hospital_id } = hospital

          hospital.cartorio_id = this.$store.state.auth.cartorio_id

          delete hospital["hospital_id"]

          let data = await HospitaisService.updateHospitais(hospital, hospital_id)

          if (data.hospital_id) {
            if (alert) {
              objSwal.success.title = "Atualizado com sucesso!"
              objSwal.success.text = ''
              this.init()
              Swal.fire(objSwal.success)
            }
            loader({ text: "", active: false })
          } else {
            objSwal.warning.title = "Erro ao atualizar, tente novamente!"
            Swal.fire(objSwal.warning)
            loader({ text: "", active: false })
          }
        } catch (error) {
          const message = getErrors(error)

          return displayMessage('error', 'Erro!', message.message)
        } finally {
          this.init()

          loader({ text: "", active: false })
        }
      },
      previousPage () {
        this.isBusy = !this.isBusy
        this.page -= 1
        this.init()
      },
      nextPage () {
        this.isBusy = !this.isBusy
        this.page += 1
        this.init()
      },
      async searchHospital () {
        this.isBusy = true
        let hospitais = await HospitaisService.getHospitais({
          cartorio_id: this.$store.state.auth.cartorio_id,
          nome: this.search
        })
        this.hospitais = hospitais.data
        this.lastPage = hospitais.lastPage
        this.isBusy = false
      },
      updateAtivo (data) {
        const obj = {
          hospital_id: data.hospital_id,
          endereco: data.endereco,
          nome: data.nome,
          ativo: !data.ativo
        }
        this.updateHospital(obj,false)
      },
      changeRead () {
        this.read = !this.read
      },
      changeData (data) {
        this.form.endereco = data
      },
    }
  }
</script>

<style lang="scss" >
  @import "../../scss/_utilities/_exports";

  .button_edit_label_icon {
    fill: #fff;
  }

  .button_delete_label_icon {
    fill: #fff;
  }

  .hospitais{
    &_title {
      background-color: $sinoreg-blue;
      color: $color-white;
      font-size: pxToRem(24);
      font-weight: 500;
      padding: pxToRem(10) pxToRem(20);
    }

    &_label {
      font-size: pxToRem(16);
    }
  }
</style>
